/* THE CART — docs/cart.md. Drives the pop-out (<dialog data-nhp-cart-drawer>) and the /cart page.
   Replaces Skeleton's drawer script from main.js but keeps its public API, so every caller still works:
     window.NNCart.open() · close() · refresh() · add(id, qty) · addAndOpen(id, qty)
   Every change goes to Shopify's cart API with `sections`, and the returned HTML (drawn by
   snippets/nhp-cart-body.liquid) replaces each [data-nhp-swap] region — Liquid stays the only
   thing that knows how the cart looks, so the pop-out and the page cannot drift apart.
   Also dispatches `nhp:cart` and rewrites [data-cart-count]; the header board and the popcorn
   bucket listen to those. README trap: this storefront's dialog.close() fires NO close event, so
   all cleanup is in close() itself. */
(function () {
  var dialog = document.querySelector('[data-nhp-cart-drawer]');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null;
  var busy = false;
  var closeTimer = 0;

  function roots() { return [].slice.call(document.querySelectorAll('[data-nhp-cart-root]')); }
  function ids() { return roots().map(function (r) { return r.getAttribute('data-nhp-cart-root'); }).join(','); }
  function unlocked() { return !!document.querySelector('[data-nhp-cart-root] [data-nhp-ship].is-unlocked'); }

  /* errors show on screen; routine updates are for screen readers only */
  function say(text, isError) {
    document.querySelectorAll('[data-nhp-cart-msg]').forEach(function (m) {
      m.textContent = text || '';
      m.classList.toggle('is-error', !!isError);
    });
  }

  /* Swap the re-rendered regions in. Focus survives by its data-nhp-focus key, and the scroll
     container is static, so tapping + halfway down the cart doesn't jump you to the top. */
  function apply(sections) {
    if (!sections) return;
    var had = document.activeElement && document.activeElement.getAttribute('data-nhp-focus');
    roots().forEach(function (r) {
      var html = sections[r.getAttribute('data-nhp-cart-root')];
      if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nhp-cart-root]');
      if (!fresh) return;
      r.querySelectorAll('[data-nhp-swap]').forEach(function (old) {
        var n = fresh.querySelector('[data-nhp-swap="' + old.getAttribute('data-nhp-swap') + '"]');
        if (n) old.replaceWith(document.importNode(n, true));
      });
      r.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    });
    syncSample();
    if (had) {
      var back = document.querySelector('[data-nhp-cart-root] [data-nhp-focus="' + had + '"]');
      if (back) back.focus({ preventScroll: true });
    }
  }

  /* PREVIEW — the sample cart (snippets/nhp-cart-sample.liquid). The bar switches states; + ADD moves
     it on one (empty → under → unlocked); crossing into unlocked plays the real strike. */
  var PV_NEXT = { empty: 'below', below: 'unlocked', unlocked: 'unlocked', all6: 'all6' };

  function syncSample() {
    roots().forEach(function (r) {
      if (!r.querySelector('[data-nhp-s]')) return;
      var st = r.getAttribute('data-sample') || 'below';
      r.setAttribute('data-sample', st);
      r.querySelectorAll('.nhp-cart__pv-btn').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-nhp-pv') === st));
      });
    });
  }

  function setSample(r, st) {
    var was = r.getAttribute('data-sample') || 'below';
    r.setAttribute('data-sample', st);
    syncSample();
    if (!reduce && (was === 'empty' || was === 'below') && (st === 'unlocked' || st === 'all6')) {
      var g = r.querySelector('[data-nhp-sship]');
      if (g) { g.classList.remove('is-strike'); void g.offsetWidth; g.classList.add('is-strike'); }
    }
  }

  function broadcast(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    document.dispatchEvent(new CustomEvent('nhp:cart', { detail: cart }));
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Free shipping just crossed the line: lightning hits the gauge, the words burn in, the syrup
     runs over. Only on the crossing — a reload or a reopen shows the settled state, never a replay. */
  function strike() {
    if (reduce) return;
    setTimeout(function () {
      document.querySelectorAll('[data-nhp-cart-root] [data-nhp-ship].is-unlocked').forEach(function (el) {
        el.classList.remove('is-strike');
        void el.offsetWidth;
        el.classList.add('is-strike');
      });
    }, dialog && dialog.classList.contains('is-open') ? 120 : 380);
  }

  function mutate(path, body) {
    var before = unlocked();
    body.sections = ids();
    body.sections_url = location.pathname;
    busy = true;
    roots().forEach(function (r) { r.setAttribute('aria-busy', 'true'); });
    say('');
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function (j) {
        apply(j.sections);
        /* change.js returns the cart; add.js returns the items, so fetch the cart for the listeners */
        return j.item_count != null && j.items ? j : getCart();
      })
      .then(function (cart) {
        broadcast(cart);
        say(cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in your cart');
        if (!before && unlocked()) strike();
        return cart;
      })
      .catch(function (err) {
        /* Shopify's own words (e.g. the stock limit) — never invented */
        say((err && (err.description || err.message)) || 'Something went wrong. Try again.', true);
        throw err;
      })
      .finally(function () {
        busy = false;
        roots().forEach(function (r) { r.removeAttribute('aria-busy'); });
      });
  }

  function refresh() {
    var before = unlocked();
    var q = ids();
    var p = q
      ? fetch(location.pathname + '?sections=' + encodeURIComponent(q), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).then(apply)
      : Promise.resolve();
    return p.then(getCart).then(function (cart) {
      broadcast(cart);
      if (!before && unlocked()) strike();
      return cart;
    });
  }

  function add(id, qty) {
    return mutate('cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] });
  }

  function open() {
    /* on the cart page the cart is already the page */
    var page = document.querySelector('[data-nhp-cart-page]');
    if (page) { page.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); return; }
    if (!dialog) { location.href = ROOT + 'cart'; return; }
    clearTimeout(closeTimer);
    if (!dialog.open) {
      lastFocus = document.activeElement;
      dialog.showModal();
    }
    document.documentElement.classList.add('nhp-cart-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { dialog.classList.add('is-open'); }); });
  }

  function close() {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('nhp-cart-open');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      dialog.close();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }, reduce ? 0 : 320);
  }

  if (dialog) {
    /* Esc: take over the native close so the slide-out and the cleanup run */
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    /* a tap on the dimmed page (the ::backdrop reports as the dialog itself) */
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
    });
    /* backstop only (see README trap) */
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('nhp-cart-open'); dialog.classList.remove('is-open'); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nhp-cart-close]')) { e.preventDefault(); close(); return; }
    var pv = e.target.closest('[data-nhp-cart-root] [data-nhp-pv], [data-nhp-cart-root] [data-nhp-pv-add]');
    if (pv) {
      var pr = pv.closest('[data-nhp-cart-root]');
      setSample(pr, pv.hasAttribute('data-nhp-pv') ? pv.getAttribute('data-nhp-pv') : PV_NEXT[pr.getAttribute('data-sample') || 'below']);
      return;
    }
    var step = e.target.closest('[data-nhp-cart-root] [data-nhp-qty]');
    if (step) {
      e.preventDefault();
      if (busy) return;
      mutate('cart/change.js', { id: step.getAttribute('data-key'), quantity: parseInt(step.getAttribute('data-nhp-qty'), 10) || 0 }).catch(function () {});
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nhp-cart-root] [data-nhp-add-form]');
    if (!form) return;
    e.preventDefault();
    if (busy) return;
    var items = [];
    var single = form.querySelector('input[name="id"]');
    if (single) items.push({ id: Number(single.value), quantity: 1 });
    form.querySelectorAll('input[name="items[][id]"]').forEach(function (i) { items.push({ id: Number(i.value), quantity: 1 }); });
    if (items.length) mutate('cart/add.js', { items: items }).catch(function () {});
  });

  /* back/forward cache can restore a stale cart */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.NNCart = {
    open: open,
    close: close,
    refresh: refresh,
    add: add,
    addAndOpen: function (id, qty) { open(); return add(id, qty); }
  };

  syncSample();
  getCart().then(broadcast);
})();
